import { twMerge } from "tailwind-merge";
import { CommandJob } from "~/components/build/Show/lib/types";
import PipelineStateIcon, {
  colorForJob,
} from "~/components/shared/PipelineStateIcon/PipelineStateIcon";
import { Label } from "~/components/build/Show/components/Sidebar/TreeNode/Label";
import { JobRetries } from "~/components/build/Show/components/Sidebar/TreeNode/JobRetries";
import { useBuild, useRetriesForJob } from "~/components/build/Show/lib/BuildContext";
import { RunDuration } from "~/components/job/Job/JobDuration";
import { CommandStep, isDefaultCommandStep, isParallelCommandStep } from "~/lib/pipeline";
import { StateIcon } from "~/components/Playground/Node/BaseNode/StateIcon";
import { textColorForStep } from "~/components/Playground/Node/colors";
import { ParallelJobIndex } from "~/components/build/Show/components/ParallelJobIndex";
import { ParallelCommandJob } from "~/components/build/Show/lib/types/CommandJob";
import Emojify from "~/components/shared/Emojify";
import { useStepDependencies } from "~/components/build/Show/lib/useStepDependencies";

/** @deprecated Use `~/components/build/Show/routes/list/-components/TreeNode/JobLabel` instead. */
export const JobLabel = ({ job, step }: { job: CommandJob; step: CommandStep }) => {
  const { build } = useBuild();
  const retries = useRetriesForJob(job, { includeLatest: false });
  const { missingDependencies } = useStepDependencies(step.uuid);

  const waitingOnConcurrencyGroup = job.state === "limited";
  const waitingOnPlatformLimit = job.state === "platform_limited";
  const name = job.name || job.command || "";

  return (
    <Label
      info={retries.length > 0 && <JobRetries job={job} />}
      duration={job.startedAt && <RunDuration job={job} />}
      status={
        isDefaultCommandStep(step) ? (
          <StateIcon
            {...step}
            waitingOnConcurrencyGroup={waitingOnConcurrencyGroup}
            waitingOnPlatformLimit={waitingOnPlatformLimit}
            missingDependencies={missingDependencies}
            className={twMerge(
              "-mr-0.5",
              textColorForStep({
                ...step,
                waitingOnConcurrencyGroup,
                waitingOnPlatformLimit,
                missingDependencies,
              }),
            )}
          />
        ) : (
          <PipelineStateIcon
            job={job}
            className={twMerge("-mr-0.5 w-4", colorForJob(job, build))}
            style={{ width: undefined, height: undefined }}
          />
        )
      }
    >
      <div className="inline space-x-1">
        {isParallelCommandStep(step) && <ParallelJobIndex job={job as ParallelCommandJob} />}
        <Emojify text={name} />
      </div>
    </Label>
  );
};
